import React from 'react';
import Header from 'src/presentation/components/ui/Header';
import styled, { css } from 'styled-components';

interface ComponentProps {
  title: string;
}

const Root = styled.div`
  ${() => css``}
`;

const PageHeader = ({ title }: ComponentProps) => {
  return (
    <Root>
      <Header level={'h1'}>{title}</Header>
    </Root>
  );
};

export default PageHeader;
